var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconThumbsUpLight = function SvgIconThumbsUpLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_thumbs_up_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.211 21.224a.21.21 0 0 0-.011.076v13.6a.21.21 0 0 0 .015.085l.009.004A.21.21 0 0 0 12.3 35H17V21.2h-4.7a.21.21 0 0 0-.085.015.057.057 0 0 0-.004.009ZM10 21.3c0-1.308.992-2.3 2.3-2.3h6.9v18.2h-6.9c-1.308 0-2.3-.992-2.3-2.3V21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.73 11.182C22.146 10.376 22.953 10 23.7 10h.6c3.115 0 5.348 2.876 4.564 5.878l-.001.005L28.032 19H33.5c2.861 0 5.121 2.604 4.48 5.514l-1.696 9.774v.003c-.39 2.203-2.327 3.909-4.584 3.909H21.2a1.337 1.337 0 0 1-.38-.054 2.822 2.822 0 0 1-.148-.046h-.044L16.9 36.902V19.813l4.83-8.631Zm1.949 1.02-.006.013-4.573 8.172v14.911l1.944.625c.054.01.1.022.136.031.057.016.114.034.148.046H31.7c1.143 0 2.204-.893 2.417-2.09v-.001l1.704-9.825.006-.028c.336-1.478-.798-2.856-2.327-2.856h-8.332l1.568-5.88c.415-1.597-.752-3.12-2.436-3.12h-.6a.091.091 0 0 0-.021.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_thumbs_up_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h28.2v28.2H0z"
  })))));
};
export default SvgIconThumbsUpLight;